import { usePathParam } from '@atlassian/react-resource-router';

export const useProjectKeyFromPath = () => {
	const [projectKey] = usePathParam('projectKey');

	return projectKey;
};
